import { render, staticRenderFns } from "./SDCardActions.vue?vue&type=template&id=20a1fff6&scoped=true&"
import script from "./SDCardActions.vue?vue&type=script&lang=js&"
export * from "./SDCardActions.vue?vue&type=script&lang=js&"
import style0 from "./SDCardActions.vue?vue&type=style&index=0&id=20a1fff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a1fff6",
  null
  
)

export default component.exports